import { CompanyProfile } from 'pages';
import { PRODUCT_PERMISSIONS, USER_PERMISSIONS } from 'dyl-components';

const PARENT_NAME = "account_management";

export const ACCOUNT_MANAGEMENT_SETTINGS = [
    { 
        path: `company-profile`, 
        icon: 'fas fa-building', 
        header: 'Company Profile', 
        description: 'Complete your company contact info and email signature.',
        page: CompanyProfile,
        type: `${PARENT_NAME}.company_profile`,
        userPermission: USER_PERMISSIONS.COMPANY_PROFILE_VIEW
    },
    { 
        path: `billing/overview`, 
        icon: 'fas fa-credit-card', 
        header: 'Billing', 
        description: 'Access your billing information.',
        page: null,
        type: `${PARENT_NAME}.billing`,
        userPermission: USER_PERMISSIONS.BILLING_VIEW
    },
    { 
        path: `usage-stats/texts`, 
        icon: 'fas fa-chart-line', 
        header: 'Usage Stats', 
        description: 'View your usage stats.',
        page: null,
        type: `${PARENT_NAME}.usage_stats`,
        productPermission: PRODUCT_PERMISSIONS.SETTINGS_USAGE_STATS,
        userPermission: USER_PERMISSIONS.USAGE_STATS_VIEW,
    }
];
